<template>
  <v-text-field
    v-if="type === 'text'"
    cols="cols"
    dense
    :label="text"
    clearable
    v-model="search[value]"
    @change="updateParent"
    hide-details="auto"
    outlined
  ></v-text-field>
  <br v-else-if="type === 'emptyLine'" />
  <v-select
    v-else-if="type === 'select'"
    cols="cols"
    dense
    :label="text"
    v-model="search[value]"
    :items="headerSelects[value]"
    hide-details="auto"
    @change="onChange ? doOnClick(value) : updateParent()"
    outlined
    clearable
  ></v-select>
  <v-autocomplete
    v-else-if="type === 'autocomplete'"
    cols="cols"
    dense
    :label="text"
    v-model="search[value]"
    :items="headerSelects[value]"
    hide-details="auto"
    @change="onChange ? doOnClick(value) : updateParent()"
    outlined
    clearable
  ></v-autocomplete>
</template>


<script>
export default {
  name: "SearchInputFieldsSelector",
  props: {
    header: {
      typeof: Object,
      required: true,
    },
    headerSelects: {
      typeof: Array,
      required: true,
    },
    searchPassed: {
      typeof: Array,
      required: true,
    },
  },
  data() {
    return {
      search: this.searchPassed
    }
  },
  computed: {
    type(){
      return this.header.type;
    },
    text(){
      return this.header.text;
    },
    onChange(){
      return this.header.onChange;
    },
    value(){
      return this.header.value;
    },
  },
  methods: {
    updateParent() {
      this.$emit("updateParent", this.search);
    },
    doOnClick(valueName) {
      this.updateParent();
      this.$emit("doOnClick", valueName);
    },
  },
};
</script>